// import styles from 'styles/ElementPicker.css';
import { Component, PropTypes } from 'react';
import { ROOT_ID } from 'main';
import { MODE } from 'constants/mode';
import { nearestElement } from 'utils/dom';
import { debounce } from 'utils/underscore_cust';

export default class ElementPicker extends Component {

  static propTypes = {
    enabled: PropTypes.bool.isRequired,
    editorState: PropTypes.object,
    onHover: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  constructor (...args) {
    super(...args);
    this.state = {
      hoveredElement: null
    };
  };

  componentDidMount () {
    this.addEventListners();
  };

  componentWillUnmount () {
    this.removeEventListeners();
  };

  componentWillUpdate (nextProps) {
    if (nextProps.editorState.mode !== this.props.editorState.mode) {
      if (nextProps.editorState.mode === MODE.EDIT) {
        this.addEventListners();
      } else {
        this.removeEventListeners();
      }
    }
  }

  render () {
    return null;
  };

  addEventListners = () => {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('click', this.onClick, true);
  };

  isEditor (element) {
    let root = document.getElementById(ROOT_ID);
    return !root || root.contains(element);
  };

  onMouseMove = debounce((e) => {
    if (!e.target || e.shiftKey) {
      return;
    }
    this.handleMouseMove(e);
  }, 50);

  handleMouseMove = e => {
    let targObj = this.getEventTarget(e, 'hover');
    const {mode} = this.props.editorState;
    if (!mode === MODE.EDIT || !this.props.enabled) {
      return;
    }

    // don't show hover if we're over the app or shift is being pressed
    if (!e.target || e.shiftKey || this.isEditor(e.target)) {
      if (this.state.hoveredElement) {
        this.props.onHover(null);
      }
      this.setState({...this.state, hoveredElement: null});
    } else {
      const elToHighlight = nearestElement(targObj[0]);
      if (this.state.hoveredElement !== elToHighlight) {
        this.props.onHover(elToHighlight);
      }
      this.setState({...this.state, hoveredElement: elToHighlight});
    }
  };

  onClick = e => {
    if (!e.isTrusted) return;
    let [targ, shadowRoot] = this.getEventTarget(e, 'click');
    const {mode} = this.props.editorState;
    if (mode === MODE.EDIT && !e.shiftKey && !this.isEditor(e.target)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.props.enabled) {
        // console.log('e.target', e, e.target.nextElementSibling);
        this.props.onSelect(targ, shadowRoot);
      }
      // adboe link tracking has a delayed navigation relying on href
      // preseving the href and restore after 500ms
      const t = e.target;
      if (t && t.tagName && t.tagName.toLowerCase() === 'a' && t.href) {
        const originalHref = t.href;
        t.setAttribute('href', window.location);
        setTimeout(function () { t.setAttribute('href', originalHref); }, 500);
      }
    }
  };

  getTargetInShadowDOM = (e, target, eventType) => {
    if (target.shadowRoot && e.composedPath) {
      const composedPathArr = e.composedPath();
      if (composedPathArr && composedPathArr.length > 0 && target !== composedPathArr[0]) {
        let parentShadowRoot = null;
        for (let i = 0; i < composedPathArr.length; i++) {
          if (composedPathArr[i].nodeType === 11) {
            parentShadowRoot = composedPathArr[i];
            break;
          }
        }
        return [composedPathArr[0], parentShadowRoot];
      } else if (e.path && e.path.length > 0 && eventType === 'hover') {
        return [e.path[0], null];
      }
    }
    return [null, null];
  }

  // an implementation that support shadow dom
  getEventTarget = (evt, eventType) => {
    var targ = evt.target || evt.srcElement || evt.originalTarget;
    let shadowRoot = null;
    if (targ && targ.nodeType === Node.TEXT_NODE && targ.parentNode) {
      // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
      targ = targ.parentNode;
    }
    let targInShadowDOM = this.getTargetInShadowDOM(evt, targ, eventType);
    if (targInShadowDOM[0]) {
      targ = targInShadowDOM[0];
      shadowRoot = targInShadowDOM[1];
    }

    return [targ, shadowRoot];
  }

  removeEventListeners = () => {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('click', this.onClick, true);
  };
}



/** WEBPACK FOOTER **
 ** ./src/views/ElementPicker.js
 **/